import Cookies from "js-cookie";

import { GEO_ALLOWED } from "~/constants/user-cookies";

export const setGeoStatusToCookies = (status: 1 | 0): void => {
  Cookies.set(GEO_ALLOWED, status.toString(), { expires: 30 });
};
